import { render, staticRenderFns } from "./PlanAppointmentForm.vue?vue&type=template&id=8c1f0d18"
import script from "./PlanAppointmentForm.vue?vue&type=script&lang=ts"
export * from "./PlanAppointmentForm.vue?vue&type=script&lang=ts"
import style0 from "./PlanAppointmentForm.vue?vue&type=style&index=0&id=8c1f0d18&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports